<template>
    <b-row>
        <b-col cols="12">
            <h4 class="mb-3">
                {{ $t('general.abono', { abono: teatro.texto_abono.charAt(0).toUpperCase() + teatro.texto_abono.slice(1) }) }} {{ index + 1 }}
            </h4>
        </b-col>
        <b-col cols="12">
            <b-row>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.name"
                        :id="'nombre-' + index"
                        rules="required"
                        :label="$t('formularios.nombre')"
                        :name="$t('formularios.nombre')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <FormInput
                        v-model="abono.lastName"
                        rules="required"
                        :id="'apellidos-' + index"
                        :label="$t('formularios.apellidos')"
                        :name="$t('formularios.apellidos')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.genero') }}</label>
                            <multiselect
                                v-model="abono.gender_object"
                                label="name"
                                track-by="id"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                :id="'genero-' + index"
                                :placeholder="$t('formularios.genero')"
                                :options="generos"
                                @select="formatGender"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <DocumentoTipo
                        :value="abono.identification.type"
                        :index="index"
                        @input="val => { abono.identification.type = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <DocumentoValor
                        :type="abono.identification.type"
                        :value="abono.identification.value"
                        :index="index"
                        @input="val => { abono.identification.value = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Paises
                            ref="paises"
                            :pais="pais?.iso3 ? pais : null"
                            :desactivar="false"
                            @paisesCargados="onPaisesCargados"
                            @rellenarPais="rellenarPais"
                            @selected="opt => { pais = opt; abono.address.country = opt.iso3; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Provincias
                            ref="provincias"
                            :desactivar="false"
                            :pais="pais.id"
                            :provincia="provincia"
                            @provinciasCargadas="onProvinciasCargadas"
                            @selected="opt => { provincia = opt; abono.address.state = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Locations
                            :localidad="localidad"
                            :desactivar="false"
                            :provincia="provincia"
                            @localidadesCargadas="onLocalidadesCargadas"
                            @selected="opt => { abono.address.city = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.zipCode"
                        rules="required"
                        :id="'cp-' + index"
                        :label="$t('formularios.cp')"
                        :name="$t('formularios.cp')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.streetLine1"
                        rules="required"
                        :id="'direccion-' + index"
                        :label="$t('formularios.domicilio')"
                        :name="$t('formularios.domicilio')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <FormInput
                        v-model="abono.birthday"
                        rules="required"
                        :id="'fecha-nacimiento-' + index"
                        type="date"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email"
                        rules="required"
                        :vid="'confirmation-' + index"
                        :id="'email-' + index"
                        type="email"
                        :label="$t('formularios.email')"
                        :name="$t('formularios.email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email_confirm"
                        :id="'email-confirm-' + index"
                        type="email"
                        :rules="'required|confirmed_ci:@confirmation-' + index"
                        :label="$t('formularios.confirmar_email')"
                        :name="$t('formularios.confirmar_email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <label :for="'telefono-' + index">{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            :name="'telefono-' + index"
                            :phone="abono.phone ?? null"
                            :required="true"
                            :error_telefono="abono.error_telefono"
                            @setNumber="(number) => abono.phone = number"
                            @validNumber="(valid) => abono.isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <b-col cols="12" class="mt-3" v-if="abono.identification?.type !== 'NIF' && esMenorDeEdad">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" :id="'no_mi_identificacion-' + index" v-model="abono.hasNotOwnIdentification"/>
                        <label :for="'no_mi_identificacion-' + index" class="custom-control-label h5 mt-1">
                            {{ $t('eventos_sga.checkBox_identificacion') }}
                        </label>
                    </div>
                </b-col>
                <b-col cols="12" class="m-3">
                    <hr/>
                </b-col>
                <b-col cols="12" v-if="abono.solicitar_documentacion === true">
                    <div class="form-group">
                        <label>
                            {{ textoDocumentacionLabel }}
                        </label>
                        <p v-if="abono.documentaciones && abono.documentaciones.length > 0" class="text-success small mb-2">
                            Documentación adjunta: {{ abono.documentaciones.length }} archivo(s).
                        </p>
                        <Dropzone
                            v-if="dropzoneUrl"
                            :url="dropzoneUrl"
                            :maxFiles="5"
                            :maxFilesize="20"
                            @success="imagenSubida"
                            @removed="imagenEliminada"
                            acceptedFiles="image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf"
                        />
                        <h3 style="font-size: 19px;">Peso máximo: 20 MB</h3>
                        <div v-if="abono.documentacion_error === true" class="alert alert-danger mt-2 mb-2" role="alert">
                            {{ $t('nuevo_abono.error_documentacion') }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue';
    import Provincias from "../../../../common/forms/Provincias";
    import Locations from "../../../../common/forms/Locations";
    import Paises from "../../../../common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";
    import Dropzone from '@/components/common/Dropzone';
    import { useEsMenorDeEdad } from "@/composables/common/useEsMenorDeEdad";
    import store from '@/store';

    const props = defineProps({
        datosAbonosLocal: {
            type: Object,
            required: true
        },
        generos: {
            type: Array,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    });

    const emit = defineEmits(['update:datosAbonosLocal']);


    const provincia = ref(null);
    const localidad = ref(null);
    const pais = ref({ id: 0 });
    const instance = getCurrentInstance();
    const teatro = computed(() => store.getters.getTeatro);
    const configuracion = computed(() => store.getters.getConfig);
    const dropzoneUrl = computed(() => {
        const base = instance?.proxy?.config?.API_BASE || '';
        const hash = teatro.value?.hash_teatro || configuracion.value?.hash_teatro || '';
        if (!base || !hash) {
            return null;
        }
        return base + '/f/upload/documento?tid=' + hash;
    });
    const textoDocumentacionLabel = computed(() => {
        const t = props.datosAbonosLocal?.texto_documentacion;
        return t || 'Adjuntá la documentación requerida';
    });

    const imagenSubida = (file, response) => {
        // Defensive id extraction: backend response shape is not formally contracted.
        // Mirrors RenovarAbonoLfp.vue:226-236.
        const id = response?.id
            ?? response?.data?.id
            ?? (typeof response === 'number' || typeof response === 'string' ? response : null);
        if (id === null || id === undefined || id === '') {
            return;
        }
        if (!Array.isArray(abono.value.documentaciones)) {
            abono.value.documentaciones = [];
        }
        // Tag the upload id on the file object so imagenEliminada can splice it
        // back out when the user removes the file from the Dropzone UI.
        // Fallback path (xhr.response) is used if the file reference is lost.
        file._documentacionId = id;
        abono.value.documentaciones.push(id);
        // Clear inline validation error on successful upload.
        abono.value.documentacion_error = false;
    };

    const imagenEliminada = (file, error, xhr) => {
        // Dropzone invokes (file, error, xhr) when a file is removed. We tagged
        // the id on the file object at upload time (see imagenSubida); fall back
        // to parsing xhr.response if the file reference is missing.
        let id = file?._documentacionId;
        if (id === null || id === undefined) {
            try {
                const parsed = xhr?.response ? JSON.parse(xhr.response) : null;
                id = parsed?.id ?? parsed?.data?.id ?? null;
            } catch (_) {
                id = null;
            }
        }
        if (id === null || id === undefined) {
            return;
        }
        if (!Array.isArray(abono.value.documentaciones)) {
            return;
        }
        const idx = abono.value.documentaciones.indexOf(id);
        if (idx >= 0) {
            abono.value.documentaciones.splice(idx, 1);
        }
        // If the item still requires docs and the user just removed the last one,
        // surface the inline error immediately (in addition to FR4 submit-time check)
        // so the user sees the gap without having to click submit first.
        if (
            abono.value.solicitar_documentacion === true
            && abono.value.documentaciones.length === 0
        ) {
            abono.value.documentacion_error = true;
        }
    };

    const abono = computed({
        get: () => props.datosAbonosLocal,
        set: value => emit('update:datosAbonosLocal', value)
    });

    const { isMinor: esMenorDeEdad } = useEsMenorDeEdad(computed(() => props.datosAbonosLocal.birthday));

    const rellenarPais = paisSeleccionado => {
        abono.value.address.country = paisSeleccionado.iso3;
    };

    const onPaisesCargados = paises => {
        if (abono.value.address.country) {
            const encontrado = paises.find(p => p.iso3 === abono.value.address.country);
            pais.value = encontrado || { id: 0 };
        }
    };

    const onProvinciasCargadas = provincias => {
        if (abono.value.address.state) {
            const encontrado = provincias.find(p => p.nombre === abono.value.address.state);
            provincia.value = encontrado || null;
        }
    };

    const onLocalidadesCargadas = localidades => {
        if (abono.value.address.city) {
            const encontrado = localidades.find(l => l.nombre === abono.value.address.city);
            localidad.value = encontrado || null;
        }
    };

    const formatGender = option => {
        switch (option.name) {
            case 'Hombre':
                abono.value.gender = 'MALE';
                break;
            case 'Mujer':
                abono.value.gender = 'FEMALE';
                break;
            default:
                abono.value.gender = 'OTHER';
                break;
        }
    };

    if (teatro.value.provincia) {
        provincia.value = teatro.value.provincia;
    }
</script>
